import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';

const { systemPropertyOwnerEmail } = loanFormModel.formField;

export class PropertyOwnerEmailValidation implements ValidationSchema {
  public name: string = systemPropertyOwnerEmail.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
}
export default new Validation(new PropertyOwnerEmailValidation());
